import React, { memo } from 'react';
interface CTAButtonProps {
  href: string;
  text: string;
  subtext?: string;
  className?: string;
}
export const CTAButton = memo(function CTAButton({
  href,
  text,
  subtext,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`block w-full max-w-xl mx-auto text-center rounded-xl py-4 px-6 transition-all duration-200
        bg-green-500 hover:bg-green-400
        shadow-[0_6px_0_rgb(21,128,61)] hover:shadow-[0_3px_0_rgb(21,128,61)]
        hover:translate-y-[3px] active:translate-y-[6px] active:shadow-none
        ${className}`} data-id="element-37">
      {/* Texto principal */}
      <span className="block text-[16px] md:text-2xl font-black uppercase tracking-wide text-white leading-tight" data-id="element-38">
        {text}
      </span>

      {/* Subtext */}
      {subtext && <span className="block text-[11px] md:text-sm font-medium mt-1 text-white/80" data-id="element-39">
          {subtext}
        </span>}
    </a>;
});